import {customerPortalSvg as Icon__small__customerPortalSvg} from '../Icon__small/Icon__small--customerPortal.js'

export var customerPortal = {
  name: 'customerPortal',
  category: 'icon',
  colorable: true,
  svg: Icon__small__customerPortalSvg,
};
